import React, { useState } from 'react';
import { TIME_SLOTS } from '../data';

export default function BookingScreen({ workshop, service, discount, onBack, onConfirm }) {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [done, setDone] = useState(false);

  const discounted = service ? Math.round(service.basePrice * (1 - discount / 100)) : 0;
  const saving     = service ? service.basePrice - discounted : 0;

  function handleConfirm() {
    if (!date || !time) return;
    setDone(true);
    onConfirm({ date, time });
  }

  /* ── Confirmation screen ── */
  if (done) {
    return (
      <div className="fade-up" style={{
        minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
        padding:20, flexDirection:'column', textAlign:'center', background:'var(--black)',
      }}>
        <div style={{ fontSize:72, marginBottom:20 }}>✅</div>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:28, fontWeight:800, color:'#fff', marginBottom:8 }}>
          Agendado!
        </h2>
        <p style={{ color:'var(--grey-3)', fontSize:15, marginBottom:28 }}>
          {workshop?.name} · {date} às {time}
        </p>

        <div style={{
          background:'linear-gradient(135deg, rgba(34,197,94,0.1), rgba(34,197,94,0.03))',
          border:'1px solid rgba(34,197,94,0.2)',
          borderRadius:'var(--radius-xl)',
          padding:28, marginBottom:28,
          width:'100%', maxWidth:340,
        }}>
          <div style={{ fontSize:13, color:'var(--grey-3)', marginBottom:6 }}>{service?.name}</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:40, fontWeight:800, color:'var(--green)', marginBottom:6 }}>
            R$ {discounted}
          </div>
          <div style={{ fontSize:14, color:'var(--grey-3)' }}>
            Você economizou{' '}
            <strong style={{ color:'var(--green)' }}>R$ {saving}</strong> com seu score AutoFácil 🎉
          </div>
        </div>

        <div style={{
          background:'var(--orange-dim)', border:'1px solid rgba(255,92,0,0.15)',
          borderRadius:'var(--radius-md)', padding:14,
          fontSize:13, color:'var(--grey-2)', lineHeight:1.6,
          maxWidth:340, marginBottom:28, textAlign:'left',
        }}>
          💡 A diferença de <strong style={{ color:'var(--orange)' }}>R$ {saving}</strong> é gerenciada pela plataforma AutoFácil.
        </div>

        <button className="btn btn-primary" style={{ padding:'14px 32px', fontSize:15 }} onClick={onBack}>
          Voltar ao início
        </button>
      </div>
    );
  }

  /* ── Booking form ── */
  return (
    <div className="fade-up" style={{ padding:'20px 20px 100px', maxWidth:500, margin:'0 auto' }}>
      <button onClick={onBack} style={{
        background:'none', border:'none', color:'var(--grey-3)',
        fontSize:14, marginBottom:24, display:'flex', alignItems:'center', gap:6, cursor:'pointer',
      }}>
        ← Voltar
      </button>

      <h2 style={{ fontFamily:'var(--font-display)', fontSize:22, fontWeight:700, color:'#fff', marginBottom:20 }}>
        Confirmar agendamento
      </h2>

      {/* Price card */}
      <div style={{
        background:'var(--surface)', border:'1px solid var(--border)',
        borderRadius:'var(--radius-lg)', padding:20, marginBottom:24,
      }}>
        <div style={{ display:'flex', gap:14, alignItems:'center', marginBottom:16 }}>
          <span style={{ fontSize:28 }}>{service?.icon}</span>
          <div>
            <div style={{ fontWeight:700, color:'#fff', marginBottom:2 }}>{service?.name}</div>
            <div style={{ fontSize:13, color:'var(--grey-4)' }}>{workshop?.name}</div>
          </div>
        </div>
        <div style={{
          display:'grid', gridTemplateColumns:'1fr 1fr 1fr',
          paddingTop:14, borderTop:'1px solid var(--border)',
          textAlign:'center', gap:8,
        }}>
          <div>
            <div style={{ fontSize:11, color:'var(--grey-4)', marginBottom:3 }}>Normal</div>
            <div style={{ fontWeight:600, color:'var(--grey-4)', textDecoration:'line-through', fontSize:14 }}>
              R$ {service?.basePrice}
            </div>
          </div>
          <div>
            <div style={{ fontSize:11, color:'var(--grey-4)', marginBottom:3 }}>Desconto</div>
            <div style={{ fontWeight:700, color:'var(--orange)', fontSize:16 }}>-{discount}%</div>
          </div>
          <div>
            <div style={{ fontSize:11, color:'var(--grey-4)', marginBottom:3 }}>Você paga</div>
            <div style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:800, color:'var(--orange)' }}>
              R$ {discounted}
            </div>
          </div>
        </div>
      </div>

      {/* Date */}
      <div style={{ marginBottom:18 }}>
        <label style={{
          fontSize:11, fontWeight:600, color:'var(--grey-3)',
          display:'block', marginBottom:8, letterSpacing:'0.08em', textTransform:'uppercase',
        }}>Data</label>
        <input
          type="date"
          className="input"
          value={date}
          onChange={e => setDate(e.target.value)}
          min={new Date().toISOString().split('T')[0]}
          style={{ colorScheme:'dark' }}
        />
      </div>

      {/* Time */}
      <div style={{ marginBottom:24 }}>
        <label style={{
          fontSize:11, fontWeight:600, color:'var(--grey-3)',
          display:'block', marginBottom:10, letterSpacing:'0.08em', textTransform:'uppercase',
        }}>Horário</label>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8 }}>
          {TIME_SLOTS.map(t => (
            <button key={t} onClick={() => setTime(t)} style={{
              padding:'11px', borderRadius:'var(--radius-sm)',
              fontSize:14, fontWeight:600, cursor:'pointer',
              transition:'var(--transition)',
              background: time === t ? 'var(--orange)' : 'var(--surface)',
              color:       time === t ? '#fff' : 'var(--grey-3)',
              border:     `1px solid ${time === t ? 'var(--orange)' : 'var(--border)'}`,
            }}>{t}</button>
          ))}
        </div>
      </div>

      {/* Info */}
      <div style={{
        background:'var(--orange-dim)', border:'1px solid rgba(255,92,0,0.15)',
        borderRadius:'var(--radius-md)', padding:14, marginBottom:20,
        fontSize:13, color:'var(--grey-2)', lineHeight:1.65,
      }}>
        💡 Diferença de <strong style={{ color:'var(--orange)' }}>R$ {saving}</strong> aplicada pela plataforma.
        Você paga apenas <strong style={{ color:'var(--white)' }}>R$ {discounted}</strong> na oficina.
      </div>

      <button
        className="btn btn-primary"
        style={{ width:'100%', justifyContent:'center', padding:16, fontSize:16, opacity:(!date||!time)?0.45:1 }}
        onClick={handleConfirm}
        disabled={!date || !time}
      >
        Confirmar agendamento
      </button>
    </div>
  );
}
